import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

$(function(){
  $('.slider').slick({
		    arrows: false,
		    dots: false,
		    autoplay: true,
		    autoplaySpeed: 0,
		    cssEase: 'linear',
		    speed: 15000,
		    slidesToShow: 2,
		    slidesToScroll: 1,
		    variableWidth: true
		});
});


  
   

